/**
 * This file is to map delay condition , from and to BE structure, it should contain at least two functions, one that maps
 * from BE to FE structure, and the other one that maps from FE to BE structure
 */
import { ActionEvents } from "assets/js/scenes/automations/containers/editor/EventsConfigs";
import store from "assets/js/store";
import {
	convertSecondsToNearestUnit,
	convertTimeWithUnitToSeconds,
} from "assets/js/scenes/automations/containers/editor/utils/utils";
import {
	getEdge,
	getEndCoachmarkNode,
	getNextTarget,
	getShadowsForStep,
} from "assets/js/scenes/automations/containers/editor/utils/utils";
import { checkIfIncrementAttributeVariable, checkIfStripeInputVariable } from "./utils";
import { LIMIT_FEATURE, limitsFeaturesAccess } from "assets/js/utils/LimitsAndFeatures";


const parseBEUpdateContactToFE = (automation, mainStep, subStep, targetId) => {
	const events = [];
	events.push({
		id: mainStep.name,
		position: {
			x: 0,
			y: 0,
		},
		data: {
			name: ActionEvents()[2].name,
			desc: ActionEvents()[2].desc,
			type: "action",
			tileTitle: ActionEvents()[2].tileTitle,
			id: mainStep.name,
			baseId: "updateContact",
			customAttributes: mainStep.args.custom_attributes,
			initialElement: false,
			customAttributeAction: "update",
			hasStripeIntegration: checkIfStripeInputVariable(mainStep.args.custom_attributes[0]?.value) || false,
			incrementAttribute: checkIfIncrementAttributeVariable(mainStep.args.custom_attributes[0]?.value) || false,
			shadows: getShadowsForStep(automation, mainStep.name),
		},
		type: "editorNode",
	});
	const links = [];
	if (targetId) {
		links.push(getEdge("custom", mainStep.name, targetId));
	} else {
		const endCoachmark = getEndCoachmarkNode(0, 0);
		events.push(endCoachmark);
		links.push(getEdge("custom", mainStep.name, endCoachmark.id));
	}
	return {
		events: events,
		links: links,
	};
};

const incrementCustomAttribute = (FEEvent) => {
	return {
		action: "SubAutomation.Call",
		name: `${FEEvent.id}0loop`,
		args: {
			sub_automation: "get_value_list_key",
			params: {
				listItems: "${input.data.contact.custom_attributes}",
				key: FEEvent.data.customAttributes[0].name
			}
		}
	};
};

const parseFEUpdateContactToBE = (FEEvent, connectedEdges, events) => {
	let shadows = [];
	let inTos = [];
	const hasMultipleListsAsTriggers = events.filter((e) => e.data.type === "trigger" && e.data.baseId !== "manual").length > 1 && limitsFeaturesAccess(LIMIT_FEATURE.USE_EMAIL_API);

	if (FEEvent.data.customAttributes[0].value.toString().includes(`\${int(event_`)) {
		FEEvent.data.customAttributes[0].value = `\${int(${FEEvent.id}0loop_output)+1}`;
	}
	if (FEEvent.data.shadows) shadows = [...FEEvent.data.shadows];
	inTos = events
		.filter((e) => e.data.baseId == "loop")
		.filter((e) => e.data.goTo == FEEvent.id);
	if (inTos.length > 0) inTos = inTos.map((e) => `${e.id}_loop`);
	const stepsToReturn = {
		main: [
			{
				steps: [
					{
						name: `${FEEvent.id}`,
						action: "SubAutomation.Call",
						args: {
							sub_automation: FEEvent.id,
						},
						next: "end",
						shadows: shadows,
						inTos: inTos,
					},
				],
			},
		],
		sub: [
			{
				name: FEEvent.id,
				params: [],
				steps: [
					{
						name: FEEvent.id,

						action: "Contact.SetCustomAttribute",
						args: {
							custom_attributes: [{ name: FEEvent.data.customAttributes[0].name, value: FEEvent.data.customAttributes[0].value }],
							...(hasMultipleListsAsTriggers && { list_id: "input.data.listId" })
							//`\${int(${FEEvent.id}0loop_output)+1}`
						},
						next: getNextTarget(connectedEdges, events),
					},
				],
			},
		],
		reusableSubAutomations: ["emit_next_step"]
	};


	if (FEEvent.data.incrementAttribute) {
		stepsToReturn.sub[0].steps.unshift(incrementCustomAttribute(FEEvent));
		stepsToReturn.reusableSubAutomations.push("get_value_list_key");
	}

	return stepsToReturn;
};

export { parseBEUpdateContactToFE, parseFEUpdateContactToBE };
